import React from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import IChecks from 'icons/IChecks';

export type CheckButtonProps = ButtonProps & {
  onlyIcon?: boolean;
};

const CheckButtonAction = ({
  children = 'Check',
  onlyIcon = false,
  ...otherProps
}: CheckButtonProps) => {
  return (
    <Button icon={<IChecks color="Green"/>} style={{ height: 35 }} {...otherProps}>
      {!onlyIcon ? children : null}
    </Button>
  );
};

export default CheckButtonAction;

